export default __webpack_public_path__ + "static/media/SilvaBrancoOriginal.38808674.svg";